import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import enTranslation from "./enTranslation.json";
import heTranslation from "./heTranslation.json";

const getUserLanguage = () => {
  const storedLanguage = localStorage.getItem("language");
  return storedLanguage;
};

// Define translation resources for different languages
const resources = {
  en: {
    translation: enTranslation,
  },

  he: {
    translation: heTranslation,
  },
};

// Initialize i18n with the configured settings
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: getUserLanguage(),
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });

i18n.on("languageChanged", (lng) => {
  localStorage.setItem("language", lng);
});

export default i18n;
